import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { useEffect } from "react"
import { selectAuthRequested } from "../../store/auth/selectors"
import { getCurrentUser } from "../../store/users/thunks"

export const useAuthenticationHandling = (redirect: boolean) => {
    const authRequested = useAppSelector(selectAuthRequested)
    const dispatch = useAppDispatch()
    useEffect(() => {
        !authRequested && dispatch(getCurrentUser(redirect))
    }, [authRequested, dispatch, redirect])
}
